<template>
  <alert-message :type="alert.type" :message="alert.message" v-if="showAlert"></alert-message>
  <el-card class="box-card detail-screen">
    <el-row class="title">
      <el-col :span="24">{{ company.name }} ({{ company.id }})</el-col>
    </el-row>
    <el-row class="row-data" align="middle">
      <el-col :span="5"><span class="label">{{ $t('companies.detail_fields.industries') }}</span></el-col>
      <el-col :span="19">
        <span v-for="industry in company.industries" :key="industry.key">{{ industry.name }}<br></span></el-col>
    </el-row>
    <el-row class="row-data" align="middle">
      <el-col :span="5"><span class="label">{{ $t('companies.detail_fields.representative_name') }}</span></el-col>
      <el-col :span="19"><span>{{ company.representative_name }}</span></el-col>
    </el-row>
    <el-row class="row-data" align="middle">
      <el-col :span="5"><span class="label">{{ $t('companies.detail_fields.address') }}</span></el-col>
      <el-col :span="19">
        <span>{{ company.zipcode_formated }}</span><br>
        <span>{{ company.address }}</span>
      </el-col>
    </el-row>
    <el-row class="row-data" align="middle">
      <el-col :span="5"><span class="label">{{ $t('companies.detail_fields.tel') }}</span></el-col>
      <el-col :span="19"><span>{{ company.tel }}</span></el-col>
    </el-row>
    <el-row class="row-data" align="middle">
      <el-col :span="5"><span class="label">{{ $t('companies.detail_fields.mail_address') }}</span></el-col>
      <el-col :span="19"><span>{{ company.mail_address }}</span></el-col>
    </el-row>
    <el-row class="row-data" align="middle">
      <el-col :span="5"><span class="label">{{ $t('companies.detail_fields.homepage_url') }}</span></el-col>
      <el-col :span="19">
        <span v-if="company.homepage">{{ company.homepage }}</span>
        <span v-else>-</span>
      </el-col>
    </el-row>
    <el-row class="row-data" align="middle">
      <el-col :span="5"><span class="label">{{ $t('companies.detail_fields.memo') }}</span></el-col>
      <el-col :span="19"><span>{{ company.memo }}</span></el-col>
    </el-row>
    <div class="group-input"><span>{{ $t('companies.form.bank_info') }}</span></div>
     <el-row class="row-data" align="middle">
      <el-col :span="5"><span class="label">{{ $t('companies.detail_fields.bank_name') }}</span></el-col>
      <el-col :span="19"><span>{{ company.bank_name }}</span></el-col>
    </el-row>
     <el-row class="row-data" align="middle">
      <el-col :span="5"><span class="label">{{ $t('companies.detail_fields.branch_name') }}</span></el-col>
      <el-col :span="19"><span>{{ company.branch_name }}</span></el-col>
    </el-row>
     <el-row class="row-data" align="middle">
      <el-col :span="5"><span class="label">{{ $t('companies.detail_fields.bank_account_type') }}</span></el-col>
      <el-col :span="19"><span>{{ company.bank_account_type_name }}</span></el-col>
    </el-row>
     <el-row class="row-data" align="middle">
      <el-col :span="5"><span class="label">{{ $t('companies.detail_fields.bank_account') }}</span></el-col>
      <el-col :span="19"><span>{{ company.bank_account }}</span></el-col>
    </el-row>
     <el-row class="row-data" align="middle">
      <el-col :span="5"><span class="label">{{ $t('companies.detail_fields.bank_account_holder') }}</span></el-col>
      <el-col :span="19"><span>{{ company.bank_account_holder }}</span></el-col>
    </el-row>
    <div class="group-input">
      <el-row>
        <el-col :span="12">
          <span>{{ $t('companies.form.account_info') }}</span>
        </el-col>
        <el-col :span="12" class="reset-account" v-if="site != $siteType.site_partner">
          <span @click="resetAccount">{{ $t('reset_account_info')}}</span>
        </el-col>
      </el-row>
    </div>
    <el-row class="row-data" align="middle">
      <el-col :span="5"><span class="label">{{ $t('companies.detail_fields.register_date') }}</span></el-col>
      <el-col :span="19"><span>{{ formatDate(company.created_at) }}</span></el-col>
    </el-row>
    <el-row class="row-data" align="middle">
      <el-col :span="5"><span class="label">{{ $t('companies.detail_fields.last_login_date') }}</span></el-col>
      <el-col :span="19"><span>{{ formatDate(company.user_partner_last_login_datetime) }}</span></el-col>
    </el-row>
    <el-row class="row-data" align="middle">
      <el-col :span="5"><span class="label">{{ $t('companies.detail_fields.login_id') }}</span></el-col>
      <el-col :span="19"><span>{{ company.login_id }}</span></el-col>
    </el-row>
    <el-row class="row-data" align="middle">
      <el-col :span="5"><span class="label">{{ $t('companies.detail_fields.password') }}</span></el-col>
      <el-col :span="19"><span>**********</span></el-col>
    </el-row>
    <el-row class="row-data" align="middle">
      <el-col :span="5"><span class="label">{{ $t('companies.detail_fields.status') }}</span></el-col>
      <el-col :span="19"><span>{{ company.status_name }}</span></el-col>
    </el-row>
    <div class="group-input"><span>{{ $t('companies.owned_kokoron') }}</span></div>
    <el-row class="row-data" align="middle">
      <el-col :span="5"><span class="label">{{ $t('companies.detail_fields.month_kokoron') }}</span></el-col>
      <el-col :span="19">
        <span>{{ company.total_point_this_month}} ({{ company.total_money_this_month }})</span>
        <span class="ml-20">({{ currentTime }})</span>
      </el-col>
    </el-row>
    <el-row class="row-data last-row" align="middle">
      <el-col :span="5"><span class="label">{{ $t('companies.detail_fields.cumulative_kokoron') }}</span></el-col>
      <el-col :span="19">
        <span>{{ company.total_point }} ({{ company.total_money }})</span>
        <span class="ml-20">({{ currentTime }})</span>
      </el-col>
    </el-row>
    <el-row v-if="site != $siteType.site_partner">
      <el-col :span="24" class="text-center mt-35">
       <el-button type="primary" @click="redirectEdit" class="btn btn-edit">{{ $t('update') }}</el-button>
       <el-button @click="back" class="btn btn-back">{{ $t('back') }}</el-button>
      </el-col>
    </el-row>
  </el-card>
  <dialog-reset-account
    v-if="isOpenPopupReset" :openFormReset="true"
    :email="company.mail_address"
    @is-close-popup-reset="handleClosePopupReset"
    @reset-account="handleResetAccount">
  </dialog-reset-account>
</template>
<script>
  import { resetAccount } from '../../api/common'

  export default {
    props: {
      company: { type: Object, required: true, default: {} },
      urls: { type: Object, required: false, default: {} },
      site: { type: Number, required: false },
      role: { type: Number, required: false }
    },
    data() {
      return {
        isOpenPopupReset: false,
        showAlert: false,
        alert: {
          type: '',
          message: ''
        }
      }
    },
    methods: {
      formatDate(dateTime) {
        return (dateTime) ? this.$dayjs(dateTime).format('YYYY/MM/DD') : '';
      },
      resetAccount() {
        this.isOpenPopupReset = true;
      },
      back() {
         window.location.href = this.urls.index;
      },
      redirectEdit() {
        window.location.href = this.urls.edit;
      },
      handleClosePopupReset() {
        this.isOpenPopupReset = false;
      },
      handleResetAccount() {
        document.querySelector(".el-dialog__body").classList.add("disabled");
        resetAccount(this.company.mail_address, this.company.partner_user.login_id, this.$userRole.partner.company)
        .then(response => response.json())
        .then(response => {
          if (response.status_code === this.$httpStatus.success) {
            this.showAlert = true;
            this.alert = { type: 'completed', message: this.$t('reset_account_completed', [this.company.mail_address]) }
          }
        })
        .finally(() => {
          document.querySelector(".el-dialog__body").classList.remove("disabled");
          this.isOpenPopupReset = false;
        });
      }
    },
    computed: {
      currentTime() {
        return this.$dayjs().format('YY/MM/DD') + ' ' + this.$t('time_point');
      }
    },
  }
</script>
